import Form from 'components/organisms/Form';
import { Redirect, useParams } from 'react-router-dom';
import { useContext, useState } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import RelatedDocumentsModal from 'components/molecules/RelatedDocumentsModal';
import ClassificationModal from 'components/molecules/ClassificationModal';
import tipoDocEnum from 'pools/tipoDocEnum';
import './styles.scss';
import getKeyByValue from 'components/helpers/getKeyByValue';

const EditPage = () => {
  const { id, tipoDoc } = useParams();
  const tipoDocId = getKeyByValue(tipoDocEnum, tipoDoc);
  const title = `Editar ${tipoDocId === 1 ? 'Norma Técnica' : 'Desenho Padrão'}`;
  const { relatedDocumentsModal, classificationModal, documents } = useContext(GlobalContext);
  const [selectedLinks, setSelectedLinks] = useState([]);
  const [document] = useState(() => documents.find((doc) => doc.ID === parseInt(id) && doc.TipoDoc === tipoDocId));
  const [relatedData, setRelatedData] = useState({
    links: document.Links.length > 0 ? document.Links : [],
    documents: document.Documentos.length > 0 ? document.Documentos : [],
    files: [],
  });

  if (isNaN(id)) return <Redirect to="/404" />;

  return (
    <>
      <div className="editPage">
        <Form selectedDocument={document} Title={title} relatedData={relatedData} tipoDoc={tipoDocId} />
      </div>
      {relatedDocumentsModal.isVisible && (
        <RelatedDocumentsModal
          setRelatedData={setRelatedData}
          relatedData={relatedData}
          document={document}
          selectedLinks={selectedLinks}
          setSelectedLinks={setSelectedLinks}
        />
      )}
      {classificationModal.isVisible && <ClassificationModal />}
    </>
  );
};

export default EditPage;
